module.exports = __webpack_public_path__ + "img/moon-100.f74c283e.svg";